<template>
  <div>
    <!-- 设置右滑弹窗 -->
    <van-popup v-model="popup" position="right" :safe-area-inset-bottom="true">

      <div class="popup-box">
        <div class="content">

          <div v-for="(parent, level) of list" :key="level">
            <div class="title" v-if="parent.name && (!parent.data || parent.data.length)">
              <div class="left">{{parent.name}}</div>
              <div class="right" v-if="parent.value" @click="onRightTextClick(level)">
                {{parent.type == 'other' && parent.icon == 'arrow-up' ? '收起' : parent.value}}<van-icon v-if="parent.icon" :name="parent.icon"/>
              </div>
            </div>

            <div v-if="parent.type == 'input'">
              <div :class="['input-box', parent.alias]">
                <div class="left" @click="onShowPicker(parent, level, 'start')">
                  <van-field
                  class="input"
                  v-model.trim="parent.default.left"
                  :type="parent.text"
                  :placeholder="parent.placeholder.left"
                  :readonly="parent.alias == 'timer'"/>
                  <img
                  v-show="parent.default.left"
                  @click.stop="cancelTimeLeft(parent, level)"
                  src="@/assets/image/filter-picker-close@2x.png" alt=""
                  >
                </div>
                <div class="middle"><span></span></div>
                <div class="right" @click="onShowPicker(parent, level, 'end')">
                  <van-field
                  class="input"
                  v-model.trim="parent.default.right"
                  :type="parent.text"
                  :placeholder="parent.placeholder.right"
                  :readonly="parent.alias == 'timer'" />
                  <img
                  v-show="parent.default.right"
                  @click.stop="cancelTimeRight(parent, level)"
                  src="@/assets/image/filter-picker-close@2x.png" alt="">
                </div>
              </div>
              <div v-show="parent.timerButtonShow" :class="['item-box', 'item-box-three']">
                <div class="btn-box"
                v-for="(item, index) of parent.timerButtonList"
                :key="index">
                  <button
                  :class="[item.active ? 'active' : '']"
                  @click="onOtherSelectItemNoLike(parent, item, index, level)">
                      {{item.label}}
                  </button>
                </div>
              </div>
              <div v-if="parent.ranges" class="ranges">
                <div class="range" v-for="item of parent.ranges" :key="item" @click="onRangeItemClick(level, item)">
                  <button>{{item}}</button>
                </div>
              </div>
            </div>

            <div v-else-if="parent.type == 'category'" :class="['item-box', 'item-box-' + parent.row]">

              <div
              class="btn-box"
              v-for="(item, index) of parent.data"
              :key="item[parent.idKey]"
              v-if="index < parent.display"
              >
                <button
                :class="[item[parent.childKey][0].active ? 'active' : '']"
                @click="onCategoriesSelectItem(level, index, 0)"
                >
                  {{item[parent.childKey][0][parent.valueKey]}}
                  <img src="@/assets/image/mode-active.png" alt="">
                </button>
              </div>
            </div>

            <div v-else-if="parent.type == 'other'" :class="['item-box', 'item-box-' + parent.row]">
              <div
              class="btn-box"
              v-for="(item, index) of parent.data"
              :key="item[parent.idKey]"
              v-show="parent.icon == 'arrow-down' && parent.value ? (index < parent.display) : true"
              >
                <button
                :class="[item.active ? 'active' : '']"
                @click="onOtherSelectItem(parent, item, index)"
                >
                  {{item[parent.valueKey]}}
                  <img src="@/assets/image/mode-active.png" alt="">
                </button>
              </div>
            </div>
          </div>

          <div v-if="sizeDtlData.length">
            <div class="title">
              <div class="left">尺码</div>
              <div class="right" @click="onRightSizeClick">
                更多尺寸<van-icon name="arrow"/>
              </div>
            </div>

            <div :class="['item-box', 'item-box-']">
              <div class="btn-box" v-for="(items, index) of sizeDtlData" :key="items.id" v-if="index < 6" >
                <button :class="[items.active ? 'active' : '']"
                @click="sizeClick(items)"
                >
                {{items.name}}
                  <img src="@/assets/image/mode-active.png" alt="">
                </button>
              </div>
            </div>
          </div>


        </div>
        <div class="footer">
          <button @click="onReset">重置</button>
          <button class="confirm" @click="onConfirm">确认</button>
        </div>

        <van-popup
        v-if="visibleTimerInput"
        v-model="timer.showPicker"
        class="picker-popup"
        position="bottom"
        :overlay="false"
        >
          <div class="content" @click.stop="timer.showPicker = false">
            <div class="picker" @click.stop>
              <van-datetime-picker
                v-model="timer.currentDate"
                title="请选择"
                :type="timer.dateType"
                :min-date="timer.startDate"
                :max-date="timer.endDate"
                :formatter="formatter"
                @confirm="onPickerConfirm"
              />
            </div>
          </div>
        </van-popup>
      </div>
    </van-popup>
    <!-- 右滑二级栏目 -->
    <van-popup v-model="second.show" position="right" :safe-area-inset-bottom="true">
      <div class="popup-box second">
        <div class="header">{{second.title}}</div>
        <div class="content">
          <van-collapse v-model="second.showSubs" :border="false">
            <van-collapse-item
            class="collapse-item"
            v-for="(item, index) in second.data"
            :key="index"
            :title="item[second.valueKey]"
            :name="index"
            :show="item[second.childKey].length"
            value="更多">
              <div class="item-box">
                <div class="btn-box" v-for="(sub, idx) in item[second.childKey]" :key="idx">
                  <button :class="[sub.active ? 'active' : '']" @click="onCategoriesSelectItem(second.level, index, idx)">
                    {{sub[second.valueKey]}}
                    <img src="@/assets/image/mode-active.png" alt="">
                  </button>
                </div>
              </div>
            </van-collapse-item>
            <van-collapse-item disabled class="last-line" v-if="second.data.length"></van-collapse-item>
          </van-collapse>
        </div>

        <div class="footer">
          <button @click="onCategoryCancel">{{onlyCategory ? '重置' : '取消'}}</button>
          <button class="confirm" @click="onCategoryConfirm">确认</button>
        </div>
      </div>
    </van-popup>
    
    <!-- 右滑二级栏目 选择尺码 -->
    <van-popup v-model="sizeDtlShow" position="right" :safe-area-inset-bottom="true" >
      <div class="popup-box second" v-if="sizeDtlData.length">
        <div class="header">尺码</div>
        <div class="content">
          <div class="item-box">
            <div class="btn-box" v-for="(item, idx) in sizeDtlData" :key="idx">
              <button :class="[item.active ? 'active' : '']" @click="sizeClick(item)">
                {{item.name}}
                <img src="@/assets/image/mode-active.png" alt="">
              </button>
            </div>
          </div>
        </div>
        <div class="footer">
          <button @click="closeSizeDtl">取消</button>
          <button class="confirm" @click="closeSizeDtl">确认</button>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import http from "@/utils/axios";
const parse = value => JSON.parse(JSON.stringify(value))
const noop = () => {}
export default {
  data() {
    return {
      popup: false,
      onlyCategory: false,
      visibleTimerInput: false,
      timer: {
        showPicker: false,
        startDate: '',
        endDate: '',
        dateType: 'datetime',
        currentDate: new Date(),
        number: 0,
        level: 0
      },
      second: {
        data: []
      },
      list: [],
      sizeDtlData:[],
      sizeDtlShow:false,
      timeSize:null
    }
  },
  beforeDestroy() {
    document.body.removeChild(this.$el)
  },
  methods: {

    show() {
      this.recovery()
      if(this.onlyCategory) {
        this.second.show = true
      } else {
        this.popup = true
      }
    },
    recovery() {
      let ids = []
      //用户操作之后 未点击确认按钮 则恢复上一次选中的按钮
      this.list.forEach((parent, level) => {
        const target = this.lastSelected[level] || {}
        if(parent.type == 'input') {
          parent.default.left = target.left || ''
          parent.default.right = target.right || ''

          if(parent.alias == 'timer' && parent.endDateIsNow) {
            if(this.timer.level == level) {
              this.timer.endDate = new Date()
              this.$nextTick(() => {
                this.timer.currentDate = new Date()
              })
            }
            parent.endDate = new Date()
          }
        }

        if(parent.type == 'category') {
          
          parent.data.forEach((item, i) => {
            item[parent.childKey].forEach((sub, j) => {
              sub.active = Boolean(target[`${i}_${j}`])
              ids.push(sub.active)
            })
          })
        }

        if(parent.type == 'other') {
          parent.data.forEach((item, i) => item.active = Boolean(target[i]))
        }
      })
      // 是否有选择尺码
      if(this.lastSelected.sizeIdList){
        for(let i = 0;i<this.sizeDtlData.length;i++){
          if(this.lastSelected.sizeIdList.includes(this.sizeDtlData[i].ids.join(','))){
            return true
          }
        }
      }
      if(!this.hasSelect()){
        // this.sizeDtlData.forEach(item =>{
        //   item.active = false
        // })
        this.getSizeDtl(1)
      }
    },
    onRangeItemClick(level, item) {
      let [ minPrice, maxPrice ] = item.split('-'), value;

      if(!maxPrice && ( value = minPrice.match(/\d+/) ) && (value = value[0])) {
        minPrice = maxPrice = value
        minPrice.indexOf('以下') > -1 ? (minPrice = '') : (maxPrice = '');
      }

      this.list[level].default.left = minPrice
      this.list[level].default.right = maxPrice
    },
    onCategoriesSelectItem(level, index, idx) {
      const parent = this.list[level]
      const target = parent.data[index][parent.childKey][idx]
      
      target.active = !target.active
      this.getSizeDtl(parent)
    },
    getSizeDtl(data){
      clearTimeout(this.timeSize)
      this.timeSize = setTimeout(() => {
        let ids = []
        if(data != 1){
          data.data.forEach(item =>{
            item.childItems && item.childItems.forEach(items=>{
              if(items.active){
                ids.push(items.itemId)
              }
            })
          })
        }
   
        if(location.href.indexOf('brandId') == -1 && location.href.indexOf('id') == -1) return
        let branchId = location.href.includes('brandId') ? location.href.split('brandId=')[1].split('&')[0] : location.href.split('id=')[1].split('&')[0]
        const params = {
          branchId:branchId,
          categoryIdList:ids
          // categoryIdList:[51065,...ids]
        }
        http({
          url: "/order/biz/attribute/findMainSizeAttrListByCategory" ,
          method: "post",
          parmes: params,
        }).then((res) => {
          if(res.code == 200 && res.data){
            res.data.forEach(item => item.active = false)
            this.$set(this,'sizeDtlData',res.data)
          }else{
            this.$set(this,'sizeDtlData',[])
          }
        }).catch((err) => {});
      }, 500);
    },
    onOtherSelectItem(other, item, index) {
      if(other.select == 'radio') { // 单选
        other.data.forEach((item, i) => item.active = i == index ? !item.active : false)
      } else { // 复选
        other.data[index].active = !item.active
      }
    },
    onOtherSelectItemNoLike(other, item, index, level) {
      other.timerButtonList.forEach((item, i) => item.active = i == index ? true : false)
      let oneinput = this.fun_date(index) + ' 00:00:00';
      let twoinput = this.fun_date(index) + ' 23:59:59';
      
      this.list[level].default['left'] = oneinput;
      this.list[level].default['right'] = twoinput;
      // console.log(this.createDate(oneinput))
      this.list[level]['start'] = {time: oneinput, date:{number: new Date(oneinput).getTime()}}
      this.list[level]['end'] = {time: twoinput, date:{number: new Date(twoinput).getTime()}}
    },
    fun_date(num) {
      let date1 = new Date()
      let date2 = new Date(date1)
      date2.setDate(date1.getDate() - num)
      //num是正数表示之后的时间，num负数表示之前的时间，0表示今天
      let month = (date2.getMonth() + 1).toString().padStart(2, '0')
      let date = date2.getDate().toString().padStart(2, '0')
      let time2 = date2.getFullYear() + '-' + month + '-' + date
      // console.log(time2)
      return time2
    },
    cancelTimeLeft(other, level){
      other.default.left = '';
      this.list[level].timerButtonList && this.list[level].timerButtonList.forEach((item) => item.active = false);
    },
    cancelTimeRight(other, level){
      other.default.right = '';
      this.list[level].timerButtonList && this.list[level].timerButtonList.forEach((item) => item.active = false);
    },
    onReset() {
      this.list.forEach(parent => this.doReset(parent))
      this.sizeDtlData.forEach(item=>item.active = false)
      this.callReset()
    },
    reset(options = {}) {
      //重置某个层级的数据
      const parent = this.getLevelObject(options)
      const success = typeof options.success == 'function' ? options.success : noop

      if(!parent) return

      this.doReset(parent)
      
      delete this.lastSelected[parent.level]

      success.call(options, this.hasSelect())
    },
    doReset(parent) {
      if(parent.type == 'input') {
        parent.default.left = parent.default.right = ''
        parent.timerButtonList && parent.timerButtonList.forEach((item) => item.active = false);
      } else if(parent.type == 'category') {
        parent.data.forEach(item => {
          item[parent.childKey].forEach(sub => sub.active = false)
        })
      } else if(parent.type == 'other') {
        parent.data.forEach(item => item.active = false)
      }
    },
    resetCategories(fn) {
      //店铺首页 选择分类时要重置categories
      this.list.forEach((parent, level) => {
        if(parent.alias == 'categories') {
          parent.data.forEach(item => {
            item[parent.childKey].forEach(sub => sub.active = false)
          })
          delete this.lastSelected[level]
        }
      })

      fn && fn(this.hasSelect())
    },
    update(options = {}) {
      //更新某一层级的数据
      const parent = this.getLevelObject(options)
      const success = typeof options.success == 'function' ? options.success : noop

      if(!parent || parent.type == 'input') return

      options.level = parent.level
      options.data = parse(options.data)

      if(parent.type == 'category') {
        options.data.forEach(item => item[parent.childKey].forEach(sub => sub.active = false))
      } else if (parent.type == 'other') {
        options.data.forEach(item => item.active = false)
      }
      
      for(let key in parent) {
        if(options[key]) {
          parent[key] = options[key]
        }
      }

      delete this.lastSelected[options.level]

      success.call(options, this.hasSelect())
    },
    getLevelObject({ level, alias }) {
      return !level && alias ? this.list.filter(item => item.alias === alias)[0] : this.list[level - 1];
    },
    hasSelect() {
      //检查input是否有值 按钮是否有选中
      for (let level = 0; level < this.list.length; level++) {
        const parent = this.list[level];
        if(parent.type == 'input' && (parent.default.left || parent.default.right)) {
          return true
        } else if(parent.type == 'category') {
          for (let i = 0; i < parent.data.length; i++) {
            const item = parent.data[i];
            for (let j = 0; j < item[parent.childKey].length; j++) {
              const sub = item[parent.childKey][j];
              if(sub.active) {
                return true
              }
            }
          }
        } else if(parent.type == 'other') {
          for (let i = 0; i < parent.data.length; i++) {
            const item = parent.data[i];
            if(item.active) {
              return true
            }
          }
        }
      }
      // 是否有选择尺码
      if(this.lastSelected.sizeIdList){
        for(let i = 0;i<this.sizeDtlData.length;i++){
          if(this.lastSelected.sizeIdList.includes(this.sizeDtlData[i].ids.join(','))){
            return true
          }
        }
      }
      return false
    },
    onConfirm() {
      // lastSelected
      const selected = { state: false }
      
      this.lastSelected = {}

      for (let level = 0; level < this.list.length; level++) {
        
        const parent = this.list[level];
        console.log(parent.type);
        if(parent.type == 'input') {
          const { left, right } = parent.default
          this.lastSelected[level] = {
            left,
            right
          }

          if(!selected.state) {
            selected.state = Boolean(left || right)
          }

          if(parent.alias == 'price') {
            if(left && right && Number(left) > Number(right)) {
              return this.$toast('最低价格不得大于最高价格');
            }
            selected.minPrice = left
            selected.maxPrice = right
          } else if(parent.alias == 'timer') {
            if(left && right && parent.start.date.number > parent.end.date.number) {
              return this.$toast('开始时间不能大于结束时间');
            }
            
            if(left) {
              selected[this.timer.number == 1 ? 'start' : 'start' + level] = parent.start
            }
            if(right) {
              selected[this.timer.number == 1 ? 'end' : 'end' + level] = parent.end
            }
          } else {
            selected[parent.alias || parent.type + level] = { left, right }
          } 
        }

        if(parent.type == 'category') {
          console.log(parent);
          selected[parent.typeName] =[];
          selected[parent.alias] = []
          this.lastSelected[level] = {}
          parent.data.forEach((item, i) => {
            item[parent.childKey].forEach((sub, j) => {
              if(sub.active) {
                console.log(selected[parent.alias]);
                console.log(selected[parent.typeName]);

                selected[parent.alias].push(sub[parent.idKey])
                selected[parent.typeName].push(sub[parent.valueKey])
                this.lastSelected[level][`${i}_${j}`] = 1
                if(!selected.state) {
                  selected.state = true
                }
              }
            })
          })
        }

        if(parent.type == 'other') {
          selected[parent.alias || (parent.type + level)] = []
          selected[parent.logosName] =[]
          this.lastSelected[level] = {}
          parent.data.forEach((item, i) => {
            if(item.active) {
              selected[parent.alias].push(item[parent.idKey])
              selected[parent.logosName].push(item[parent.idKey])
              this.lastSelected[level][i] = 1
              if(!selected.state) {
                selected.state = true
              }
            }
          })
        }
      }

      this.popup = false
      this.second.show = false
      this.lastSelected.sizeIdList = []
      if(this.sizeDtlData.length){
        selected.sizeIdList = []
        // this.sizeDtlData.filter(v => v.active).forEach(item =>{
        //   selected.sizeIdList.push(item.ids)
        //   this.lastSelected.sizeIdList.push(item.ids.join(','))
        // })
        this.sizeDtlData.forEach(item =>{
          if(item.active){
            selected.sizeIdList.push(item.ids)
            this.lastSelected.sizeIdList.push(item.ids.join(','))
          }
          item.active = false
        })
        selected.sizeIdList = selected.sizeIdList.flat(2)
        selected.state = true
      }
      this.confirm(selected)
    },
    onCategoryCancel() {
      if(this.onlyCategory) {
        this.onReset()
      } else {
        this.second.show = false
      }
    },
    onCategoryConfirm() {
      if(this.onlyCategory) {
        this.onConfirm()
      } else {
        this.second.show = false
      }
    },
    formatter(type, value) {
      type = ({ year: '年', month: '月', day: '日', hour: '时', minute: '分'})[type] || ''
      return value + type
    },
    createDate(date) {
      const paddingZero = n => n < 10 ? '0' + n : n + '';
      const 
        Y = paddingZero(date.getFullYear()),
        M = paddingZero(date.getMonth() + 1),
        D = paddingZero(date.getDate()),
        h = paddingZero(date.getHours()),
        m = paddingZero(date.getMinutes());

      return {
        time: this.timer.dateType == 'datetime' ? `${[Y, M, D].join('-')} ${[h, m].join(':')}` : `${[Y, M, D].join('-')}`,
        date: { Y, M, D, h, m, number: Number(Y + M + D + h + m) }
      }
    },
    onRightTextClick(level) {
      const parent = this.list[level]
      if(parent.type == 'category') {
        this.second = this.list[level]
        this.second.show = true
      } else {
        parent.icon = parent.icon == 'arrow-down' ? 'arrow-up' : 'arrow-down'
      }
    },
    // 打开选择更多尺寸
    onRightSizeClick(){
      this.sizeDtlShow = true
    },
    // 关闭选择更多尺寸
    closeSizeDtl(){
      this.sizeDtlShow = false
    },
    // 选择尺寸
    sizeClick(item){
      item.active = !item.active
    },
    onShowPicker(parent, level, type) {
      if(parent.alias != 'timer') return

      if(this.timer.number > 1) {
        this.timer.startDate = parent.startDate
        this.timer.endDate = parent.endDate
        this.timer.dateType = parent.dateType
      }
      
      this.timer.clickInput = { type, level }
      this.timer.showPicker = true
    },
    onPickerConfirm(date) {
      date = this.createDate(date)
      const { type, level } = this.timer.clickInput
   
      this.list[level].default[type == 'start' ? 'left' : 'right'] = date.time
      this.list[level][type] = date
      this.list[level].timerButtonList && this.list[level].timerButtonList.forEach((item) => item.active = false);
      this.timer.showPicker = false
    },
    initData({ popup, list = [], confirm, visiblePriceInput = true, visibleTimerInput = false, visibleTimerButton = false,reset }) {
      console.log('list',list);
      if(!Array.isArray(list) && process.env.NODE_ENV !== 'production') {
        console.error('list 必须是一个数组')
        return
      }
      if(popup !== 'collapse') {
        if(visibleTimerInput) {
          list.unshift({
            type: 'input',
            alias: 'timer'
          })
        }

        if(visiblePriceInput) {
          list.unshift({
            type: 'input',
            alias: 'price'
          })
        }
      }
      
      list = list.map((item, level) => {
        item.level = level
        if(item.alias == 'logos') {
          item.title = '品牌筛选'
          item.name = item.name || '品牌'
          item.value = item.value || '更多品牌'
        }
        if(item.type == 'input') {
          if(item.alias == 'price') {
            item = Object.assign({
              name: '价格区间',
              value: '',
              text: 'digit',
              placeholder: { left: '最低价', right: '最高价' },
              default: { left: '', right: '' }
            }, item)
          } else if(item.alias == 'timer') {
            item = Object.assign({
              name: '下单时间',
              value: '',
              text: 'text',
              dateType: 'datetime',
              placeholder: { left: '开始时间', right: '结束时间'},
              default: { left: '', right: '' },
              startDate: new Date(2019, 1, 0),
              endDate: "",
              endDateIsNow: true,
              timerButtonShow: visibleTimerButton,
              select: 'radio',
              timerButtonList:[
                {id: 0, label:'今日', value:'',active:false},
                {id: 1, label:'昨日', value:'',active:false},
                {id: 2, label:'前日', value:'',active:false},
              ]
            }, item)

            this.timer.number++
            this.timer.level = level
          } else {
            item = Object.assign({
              name: '',
              value: '',
              placeholder: { left: '', right: '' },
              default: { left: '', right: '' }
            }, item)
          }
        } else if(item.type == 'category') {
          item = Object.assign({
            type: 'category',
            alias: 'categories',
            name: '品类',
            value: '更多品类',
            title: '品类筛选',
            select: 'check',
            icon: 'arrow',
            row: 'three',
            idKey: 'itemId',
            valueKey: 'itemName',
            childKey: 'childItems',
            display: 9,
            show: false,
            showSubs: [0],
            data: [],
          }, item)
          item.data = parse(item.data || [])
          item.data.forEach(child => {
            child[item.childKey].forEach(sub => sub.active = false)
          })
        } else {
          item = Object.assign({
            type: 'other',
            alias: '',
            name: '',
            value: '',
            select: 'check',
            row: 'three',
            icon: 'arrow-down',
            idKey: 'itemId',
            valueKey: 'itemName',
            display: 9,
            data: []
          }, item)
          item.data = parse(item.data || [])
          item.data.forEach(item => item.active = false)
        }
        return item
      })
      this.list = list
      this.onlyCategory = popup === 'collapse'
      this.visibleTimerInput = true
      this.lastSelected = {}
      this.confirm = typeof confirm == 'function' ? confirm : noop
      this.callReset = typeof reset =='function' ? reset:noop
      if(this.timer.number == 1) {
        const current = this.list[this.timer.level]
        this.timer.startDate = current.startDate
        this.timer.dateType = current.dateType
      }

      if(this.onlyCategory) {
        this.second = this.list[0] || {}
      }
    }
  }
}
</script>

<style lang="less" scoped>
button {
  outline: none;
  border: none;
  background: #fff;
  margin: 0;
  padding: 0;
}
.popup-box {
  width: 676px;
  height: 100vh;
  font-size: 28px;
  position: relative;
  .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 132px;
    z-index: 1;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .title {
    display: flex;
    font-weight: bold;
    padding: 30px;
    .left {
      flex: 1;
    }
    .right {
      font-size: 24px;
      color: #999;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: normal;
    }
  }
}
.input-box {
  display: flex;
  padding: 0 30px 20px 30px;
  >div {
    position: relative;
  }
  .middle {
    flex: 1;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      width: 16px;
      height: 1PX;
      background: #999999;
    }
  }
  .input {
    height: 80px;
    border-radius: 10px;
    font-size: 24px;
    background: #f2f2f2;
    /deep/input {
      text-align: center;
    }
    /deep/input::placeholder {
      color: #999999;
    }
  }
  img {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 50%;
    right: 10px;
    margin-top: -20px;
    z-index: 2;
  }
}

.ranges {
  padding: 0 20px;
  margin-top: 10px;
  .range {
    width: 25%;
    box-sizing: border-box;
    padding: 0 10px;
    display: inline-block;
    margin-bottom: 20px;
  }
  button {
    width: 100%;
    border: 2px solid #ccc;
    height: 60px;
    font-size: 24px;
    border-radius: 10px;
    color: #666;
  }
}

.timer {
  /deep/.van-cell {
    padding-left: 0;
    padding-right: 30px;
  }
}

.picker-popup {
  background-color: rgba(255, 255, 255, 0)!important;
  .content {
    position: relative;
    height: 100vh;
  }
  .picker {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 8;
    box-shadow: 0 0 10px #eee;
  }
}

.item-box {
  padding-left: 20px;
  padding-right: 24px;
  .btn-box {
    display: inline-block;
    width: 210px;
    box-sizing: border-box;
    padding: 0 10px;
    margin-bottom: 20px;
  }
  button {
    display: inline-block;
    width: 100%;
    height: 60px;
    border-radius: 10px;
    border: 2px solid #cccccc;
    box-sizing: border-box;
    font-size: 24px;
    text-align: center;  
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 20px;
    color: #333333;
    position: relative;
    img {
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: 1;
      width: 38px;
      height: 38px;
      display: none;
      line-height: 0;
    }
  }
  .active {
    border-color: #ED3939;
    color: #ED3939;
    img {
      display: block;
    }
  }
}

.item-box-two {
  padding-left: 12px;
  padding-right: 12px;
  .btn-box {
    width: 50%;
    padding: 0 18px;
  }
  button {
    height: 70px;
  }
}

.footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  font-size: 0;
  padding-top: 30px;
  padding-bottom: 60px;
  text-align: center;
  button {
    display: inline-block;
    width: 290px;
    height: 70px;
    border: 2px solid #999999;
    color: #999999;
    border-radius: 10px;
    box-sizing: border-box;
    font-size: 24px;
    font-weight: bold;
    margin: 0 18px;
  }
  .confirm {
    background: linear-gradient(90deg, #FF8200 0%, #FF1414 100%);
    color: #fff;
    border: none;
  }
}
.second {
  .header {
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    padding-top: 30px;
    padding-bottom: 40px;
  }
  .content {
    top: 116px
  }
}
.collapse-item {
  /deep/.van-collapse-item__content {
    padding-left: 0;
    padding-right: 0;
    line-height: normal;
  }
  /deep/.van-icon-arrow {
    font-size: 24px;
  }
  /deep/.van-cell__title {
    font-weight: bold;
    color: #333333;
    font-size: 24px;
  }
  /deep/.van-cell__value {
    color: #999999;
    font-size: 24px;
  }
}
.last-line {
  /deep/.van-icon-arrow {
    display: none;
  }
}
</style>
